import { ActionContext, ActionTree } from 'vuex';
import { RootState, PasswordState } from '@/store/types';
import UserService from '@/services/user.service';

const actions: ActionTree<PasswordState, RootState> = {
  async change(store: ActionContext<PasswordState, RootState>): Promise<void> {
    store.commit('clearPutError');
    store.commit('clearPutSuccess');
    return UserService.putNewPassword({
      currentPassword: store.state.password,
      newPassword: store.state.newPassword,
    })
      .then(() => {
        store.commit('clear');
        store.commit('clearPutError');
        store.commit(
          'setPutSuccess',
          'Your password has been succesfully changed.'
        );
      })
      .catch(error => {
        store.commit('setPutError', error);
      });
  },
};

export default actions;
